import { CommonModule } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { FormsModule } from "@angular/forms";

export interface LoanProduct {
  id: number;
  productCategory: string;
  productName: string;
  productCode: string;
  currencyCode: string | null;
  minCoApplicant: number | null;
  maxCoApplicant: number | null;
  minGuarantors: number | null;
  maxGuarantors: number | null;
  minLoanAmount: string | null;
  maxLoanAmount: string | null;
  minInterestRate: string | null;
  maxInterestRate: string | null;
  minLoanTenure: number | null;
  maxLoanTenure: number | null;
  defaultLoanTenure: number | null;
  tenureUnit: string | null;
  defaultInterestRate: string | null;
  effectiveFrom: string | null;
  expireDate: string | null;
  coreLmsProductCode: string | null;
  workFlow1: string | null;
  workFlow2: string | null;
  workFlow3: string | null;
  workFlow4: string | null;
  workFlow5: string | null;
  rules1: string | null;
  rules2: string | null;
  rules3: string | null;
  rules4: string | null;
  rules5: string | null;
  adaptiveUiCode: string | null;
}

@Component({
  selector: "app-product",
  imports: [CommonModule, FormsModule],
  templateUrl: "./product.component.html",
  styleUrl: "./product.component.scss",
})
export class ProductComponent implements OnInit {

  products: LoanProduct[] = [
    {
      id: 18, productCategory: 'PRAYANMSME', productName: '222 MSME Loans', productCode: 'PCUL-0',
      currencyCode: null, minCoApplicant: null, maxCoApplicant: null, minGuarantors: null, maxGuarantors: null,
      minLoanAmount: null, maxLoanAmount: null, minInterestRate: null, maxInterestRate: null,
      minLoanTenure: null, maxLoanTenure: null, defaultLoanTenure: null, tenureUnit: null,
      defaultInterestRate: null, effectiveFrom: null, expireDate: null, coreLmsProductCode: null,
      workFlow1: null, workFlow2: null, workFlow3: null, workFlow4: null, workFlow5: null,
      rules1: null, rules2: null, rules3: null, rules4: null, rules5: null, adaptiveUiCode: null
    },
    {
      id: 19, productCategory: 'PRAYANMSME', productName: 'PCUL1', productCode: 'PCUL-1',
      currencyCode: null, minCoApplicant: null, maxCoApplicant: null, minGuarantors: null, maxGuarantors: null,
      minLoanAmount: null, maxLoanAmount: null, minInterestRate: null, maxInterestRate: null,
      minLoanTenure: null, maxLoanTenure: null, defaultLoanTenure: null, tenureUnit: null,
      defaultInterestRate: null, effectiveFrom: null, expireDate: null, coreLmsProductCode: null,
      workFlow1: null, workFlow2: null, workFlow3: null, workFlow4: null, workFlow5: null,
      rules1: null, rules2: null, rules3: null, rules4: null, rules5: null, adaptiveUiCode: null
    },
    {
      id: 20, productCategory: 'PRAYANMSME', productName: 'PCUL2', productCode: 'PCUL-2',
      currencyCode: null, minCoApplicant: null, maxCoApplicant: null, minGuarantors: null, maxGuarantors: null,
      minLoanAmount: null, maxLoanAmount: null, minInterestRate: null, maxInterestRate: null,
      minLoanTenure: null, maxLoanTenure: null, defaultLoanTenure: null, tenureUnit: null,
      defaultInterestRate: null, effectiveFrom: null, expireDate: null, coreLmsProductCode: null,
      workFlow1: null, workFlow2: null, workFlow3: null, workFlow4: null, workFlow5: null,
      rules1: null, rules2: null, rules3: null, rules4: null, rules5: null, adaptiveUiCode: null
    },
    {
      id: 21, productCategory: 'PRAYANMSME', productName: 'PCUL3', productCode: 'PCUL-3',
      currencyCode: null, minCoApplicant: null, maxCoApplicant: null, minGuarantors: null, maxGuarantors: null,
      minLoanAmount: null, maxLoanAmount: null, minInterestRate: null, maxInterestRate: null,
      minLoanTenure: null, maxLoanTenure: null, defaultLoanTenure: null, tenureUnit: null,
      defaultInterestRate: null, effectiveFrom: null, expireDate: null, coreLmsProductCode: null,
      workFlow1: null, workFlow2: null, workFlow3: null, workFlow4: null, workFlow5: null,
      rules1: null, rules2: null, rules3: null, rules4: null, rules5: null, adaptiveUiCode: null
    },
    {
      id: 22, productCategory: 'ConatusMSME', productName: 'Conatus Secured', productCode: 'CONTSSECRD',
      currencyCode: null, minCoApplicant: null, maxCoApplicant: null, minGuarantors: null, maxGuarantors: null,
      minLoanAmount: '100000.00', maxLoanAmount: '1500000.00', minInterestRate: '21', maxInterestRate: '25',
      minLoanTenure: 12, maxLoanTenure: 60, defaultLoanTenure: null, tenureUnit: null,
      defaultInterestRate: null, effectiveFrom: null, expireDate: null, coreLmsProductCode: null,
      workFlow1: null, workFlow2: null, workFlow3: null, workFlow4: null, workFlow5: null,
      rules1: null, rules2: null, rules3: null, rules4: null, rules5: null, adaptiveUiCode: null
    },
    {
      id: 23, productCategory: 'SME', productName: 'SME', productCode: 'SME',
      currencyCode: null, minCoApplicant: null, maxCoApplicant: null, minGuarantors: null, maxGuarantors: null,
      minLoanAmount: null, maxLoanAmount: null, minInterestRate: null, maxInterestRate: null,
      minLoanTenure: null, maxLoanTenure: null, defaultLoanTenure: null, tenureUnit: null,
      defaultInterestRate: null, effectiveFrom: null, expireDate: null, coreLmsProductCode: null,
      workFlow1: null, workFlow2: null, workFlow3: null, workFlow4: null, workFlow5: null,
      rules1: null, rules2: null, rules3: null, rules4: null, rules5: null, adaptiveUiCode: null
    },
    {
      id: 24, productCategory: 'ConsumerDurable', productName: 'CD-0', productCode: 'CD0',
      currencyCode: 'INR', minCoApplicant: 0, maxCoApplicant: 0, minGuarantors: 0, maxGuarantors: 0,
      minLoanAmount: '5000.00', maxLoanAmount: '150000.00', minInterestRate: '0', maxInterestRate: '22',
      minLoanTenure: 3, maxLoanTenure: 36, defaultLoanTenure: null, tenureUnit: null,
      defaultInterestRate: '18', effectiveFrom: '2026-03-03', expireDate: '2030-03-03', coreLmsProductCode: null,
      workFlow1: null, workFlow2: null, workFlow3: null, workFlow4: null, workFlow5: null,
      rules1: null, rules2: null, rules3: null, rules4: null, rules5: null, adaptiveUiCode: null
    },
    {
      id: 25, productCategory: 'ConsumerDurable', productName: 'CD-10', productCode: 'CD10',
      currencyCode: 'INR', minCoApplicant: 0, maxCoApplicant: 0, minGuarantors: 0, maxGuarantors: 0,
      minLoanAmount: '10000.00', maxLoanAmount: '250000.00', minInterestRate: '10', maxInterestRate: '28',
      minLoanTenure: 6, maxLoanTenure: 36, defaultLoanTenure: null, tenureUnit: null,
      defaultInterestRate: '24', effectiveFrom: null, expireDate: null, coreLmsProductCode: null,
      workFlow1: null, workFlow2: null, workFlow3: null, workFlow4: null, workFlow5: null,
      rules1: null, rules2: null, rules3: null, rules4: null, rules5: null, adaptiveUiCode: null
    }
  ];

  selectedProduct: LoanProduct = this.products[0];
  filteredProducts: LoanProduct[] = [];
  categories: string[] = [];
  activeCategory: string = 'ALL';
  searchQuery: string = '';

  // Category → Tailwind classes mapping
  private categoryStyles: Record<string, { avatar: string; badge: string }> = {
    PRAYANMSME: { avatar: 'bg-violet-100 text-violet-700', badge: 'bg-violet-100 text-violet-700' },
    ConatusMSME: { avatar: 'bg-teal-100 text-teal-700', badge: 'bg-teal-100 text-teal-700' },
    SME: { avatar: 'bg-amber-100 text-amber-700', badge: 'bg-amber-100 text-amber-700' },
    ConsumerDurable: { avatar: 'bg-rose-100 text-rose-700', badge: 'bg-rose-100 text-rose-700' },
  };

  ngOnInit(): void {
    this.categories = [...new Set(this.products.map(p => p.productCategory))];
    this.applyFilters();
  }

  selectProduct(product: LoanProduct): void {
    this.selectedProduct = product;
  }

  setCategory(cat: string): void {
    this.activeCategory = cat;
    this.applyFilters();
  }

  applyFilters(): void {
    const q = this.searchQuery.toLowerCase().trim();
    this.filteredProducts = this.products.filter(p => {
      const matchesSearch =
        !q ||
        p.productName.toLowerCase().includes(q) ||
        p.productCode.toLowerCase().includes(q) ||
        p.productCategory.toLowerCase().includes(q);
      const matchesCategory =
        this.activeCategory === 'ALL' || p.productCategory === this.activeCategory;
      return matchesSearch && matchesCategory;
    });
  }

  getInitials(name: string): string {
    return name
      .split(/\s+/)
      .slice(0, 2)
      .map(w => w[0]?.toUpperCase() ?? '')
      .join('');
  }

  getAvatarClass(category: string): string {
    return this.categoryStyles[category]?.avatar ?? 'bg-slate-100 text-slate-600';
  }

  getCategoryClass(category: string): string {
    return this.categoryStyles[category]?.badge ?? 'bg-slate-100 text-slate-600';
  }

  formatAmount(value: string | null): string {
    if (!value) return '—';
    const num = parseFloat(value);
    if (isNaN(num)) return value;
    if (num >= 100000) return (num / 100000).toFixed(num % 100000 === 0 ? 0 : 1) + 'L';
    if (num >= 1000) return (num / 1000).toFixed(num % 1000 === 0 ? 0 : 1) + 'K';
    return num.toLocaleString('en-IN');
  }

  formatDate(value: string | null): string {
    if (!value) return '—';
    const date = new Date(value);
    return date.toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' });
  }

  onProceed(): void {
    console.log('Proceeding with product:', this.selectedProduct);
    // Emit event or navigate to next step
    // this.router.navigate(['/loan-application'], { queryParams: { productId: this.selectedProduct.id } });
  }
}